import React, { Component } from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import Moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Calendar } from 'primereact/calendar';
import { AppConstants, AssessmentConstants } from '../../../shared/Constants';
import AssessmentUtil from '../../../utils/AssessmentUtil';

const messages = defineMessages({
  plhTimeLimit: {
    id: 'assessment.timeLimit',
    defaultMessage: 'Time Limit',
  },

  invalidBeforeNow: {
    id: 'errors.after',
    defaultMessage: '{description} must be after {after}',
  },
  invalidAfterLimit: {
    id: 'errors.before',
    defaultMessage: '{description} must be before {before}',
  },
});

class ExtendTime extends Component {
  constructor(props) {
    super(props);
    this.extendTimeExpiration = this.extendTimeExpiration.bind(this);
    this.checkValidTimeExpansion = this.checkValidTimeExpansion.bind(this);
    this.state = {
      expandError: {
        error: false,
        msg: null,
      },
    };
  }

  extendTimeExpiration(value) {
    if (this.checkValidTimeExpansion(value)) {
      const { onUpdateExpiration } = this.props;
      onUpdateExpiration(value);
      const { expandError } = this.state;
      expandError.error = false;
      expandError.msg = null;
      this.setState({ expandError });
    }
  }

  checkValidTimeExpansion(value) {
    const { createdAt, intl } = this.props;
    const { formatMessage } = intl;
    const { expandError } = this.state;
    if (!AssessmentUtil.isSameOrBeforeLimit(value)) {
      expandError.error = true;
      expandError.msg = formatMessage(messages.invalidAfterLimit, {
        description: '',
        before: Moment(createdAt)
          .add(AssessmentConstants.MAX_EXPANDS_TIME, 'days')
          .format(AppConstants.DATE_INPUT_FORMAT),
      });
      this.setState({ expandError });
      return false;
    }
    if (!AssessmentUtil.isSameOrAfterNow(value)) {
      expandError.error = true;
      expandError.msg = formatMessage(messages.invalidBeforeNow, {
        description: '',
        after: Moment().format(AppConstants.DATE_INPUT_FORMAT),
      });
      this.setState({ expandError });
      return false;
    }
    return true;
  }

  render() {
    const { dateValue, isDisabled } = this.props;
    const { expandError } = this.state;
    const minDate = new Date();
    const maxDate = Moment(new Date())
      .add(AssessmentConstants.MAX_EXPANDS_TIME, 'days')
      .toDate();

    return (
      <div>
        <label>
          <FormattedMessage id="assessment.extendTimeLimit" defaultMessage="Extend Time Limit">
            {text => <span>{text}</span>}
          </FormattedMessage>
          <FormattedMessage id="assessment.duration" defaultMessage="(maximum 90 days)">
            {text => <span>{text}</span>}
          </FormattedMessage>
        </label>
        <div>
          <Calendar
            value={dateValue}
            minDate={minDate}
            maxDate={maxDate}
            disabled={isDisabled}
            onChange={this.extendTimeExpiration}
            dateFormat="yy-M-dd"
          />
          {expandError.error ? <span style={{ color: '#ce4844' }}>{expandError.msg}</span> : null}
        </div>
      </div>
    );
  }
}

ExtendTime.propTypes = {
  onUpdateExpiration: PropTypes.func.isRequired,
  dateValue: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  createdAt: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};

export default injectIntl(ExtendTime);
